import React, {Fragment} from 'react';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import {Form, Input} from 'semantic-ui-react';
import {dateFormatPicker} from '../../../common/constants/datesFormat';
import DatePickerReadOnlyInput from '../../../common/components/form/datePickerReadOnly';

const SalesPartType = (props) => {
  const {tsbNo, previousNumFac, lastDate, numFacActual, actualDate, handleChange, disabledBtns} = props;

  return (
    <Fragment>
      <Form.Group widths='three'>
        <Form.Field
          disabled={disabledBtns}
          control={Input}
          label='No Fact Previa'
          placeholder='No Fact Previa'
          value={previousNumFac}
          maxLength='20'
          onChange={(e, {value}) => handleChange('previousNumFac', value)}
        />
        <Form.Input fluid label='Fecha Previa'>
          <DatePicker
            customInput={<DatePickerReadOnlyInput />}
            disabled={disabledBtns}
            placeholderText='Fecha Previa'
            className='tcc-datepicker'
            showYearDropdown
            selected={lastDate ? moment(lastDate).toDate() : null}
            dateFormat={dateFormatPicker}
            onChange={(value) => handleChange('lastDate', value)}
            loacle='es'
          />
        </Form.Input>
        <Form.Field
          disabled={disabledBtns}
          control={Input}
          label='No Fact Actual'
          placeholder='No Fact Actual'
          value={numFacActual}
          maxLength='20'
          onChange={(e, {value}) => handleChange('numFacActual', value)}
        />
      </Form.Group>
      <Form.Group widths='three'>
        <Form.Input fluid label='Fecha Actual'>
          <DatePicker
            disabled={disabledBtns}
            placeholderText='Fecha Actual'
            className='tcc-datepicker'
            showYearDropdown
            selected={actualDate ? moment(actualDate).toDate() : null}
            dateFormat={dateFormatPicker}
            onChange={(value) => handleChange('actualDate', value)}
            locale='es'
          />
        </Form.Input>
        <Form.Field
          value={tsbNo}
          control={Input}
          label='TSB No'
          placeholder='TSB No'
          onChange={(e, {value}) => handleChange('tsbNo', value)}
        />
      </Form.Group>
    </Fragment>
  );
};

export default SalesPartType;
